<template>
  <div>
    <div class="p-lg-3">
      <div class="row justify-content-between">
        <h3 class="mt-0 mb-2 font-weight-bold text-left">Orgãos</h3>
      </div>
    </div>

    <v-data-table
      v-on:update:sort-by="options.ordenacao = true"
      :footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
      :headers="headers"
      :items="orgaos"
      class="elevation-1"
      :loading="loading"
      :loading-text="'Carregando...'"
    >
      <!-- <v-data-table
      v-on:update:sort-by="options.ordenacao = true"
      :footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
      :headers="headers"
      :items="orgaos"
      :options.sync="options"
      :server-items-length="totalList"
      class="elevation-1"
      :loading="loading"
      :loading-text="'Carregando...'"
    > -->
      <template v-slot:top>
        <v-toolbar flat>
          <!-- DIALOG DE CADASTRO -->
          <v-dialog
            v-model="dialogCadastro"
            max-width="500px"
            fullscreen
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="allowCadastrarBtn"
                dark
                class="mb-2 bg-verde"
                rounded
                v-bind="attrs"
                v-on="on"
              >
                Novo Orgão
              </v-btn>
            </template>
            <v-card>
              <v-toolbar dark class="bg-verde">
                <v-btn icon dark @click="dialogCadastro = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>
                  <span class="headline">Cadastrar orgão</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items> </v-toolbar-items>
              </v-toolbar>
              <cadastro-novo-orgao
                v-if="dialogCadastro"
                @close="dialogCadastro = false"
                @response="atualizarListaOrgaos"
              />
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <!-- <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field> -->
          <!-- DIALOG DE EDIÇÃO -->
          <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <!-- :orgao="orgao_detalhe" -->
            <cadastro-edicao-orgao
              v-if="orgao_detalhe"
              :visualizar="visualizar"
              :orgaoId="orgaoId"
              :key="render"
              @close="save($event)"
            />
          </v-dialog>
          <v-dialog
            v-model="dialogObs"
            fullscreen
            hide-overlay
            scrollable
            transition="dialog-bottom-transition"
          >
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item, true)">
          mdi mdi-eye
        </v-icon>
        <v-icon
          v-if="allowEditarBtn"
          small
          class="mr-2"
          @click="editItem(item, false)"
        >
          fas fa-edit
        </v-icon>
      </template>
      <template v-slot:no-data>
        <p class="text-center">Nenhum registro encontrado</p>
        <v-btn color="#3E682A" dark @click="atualizarListaOrgaos">
          Atualizar
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CadastroEdicaoOrgao from "@/components/orgao/cadastro_edicao_orgao.vue";
import CadastroNovoOrgao from "@/components/orgao/cadastro_novo_orgao.vue";
import Mixin from "@/mixins/vuex_mixin.js";
import UnidadeService from "../services/unidade_service";
import OrgaoService from "../services/orgao_service";
import AuthService from "../services/auth_service";
import endpoints from "../router/endpoints";

export default {
  mixins: [Mixin],
  components: {
    CadastroEdicaoOrgao,
    CadastroNovoOrgao,
  },

  data: () => ({
    orgao_detalhe: {},
    render: 0,
    dialog: false,
    dialogObs: false,
    loading: false,
    search: "",
    totalList: 10,
    options: {
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
      ordenacao: false,
      desc: false,
    },
    dialogCadastro: false,
    orgao: {},
    visualizar: false,
    orgaos: [],
    headers: [
      {
        text: "Nome Fantasia",
        align: "start",
        sortable: true,
        value: "nome_fantasia",
      },
      {
        text: "Nome Razão Social",
        align: "start",
        value: "razao_social",
        sortable: false,
      },
      { text: "CNPJ", value: "cnpj", sortable: false },
      { text: "Ações", align: "end", value: "actions", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      nome: "",
      cpf: "",
      email: "",
    },
    defaultItem: {
      nome: "",
      cpf: "",
      email: "",
    },
    services: {
      unidadeService: UnidadeService.build(),
      orgaoService: OrgaoService.build(),
      authService: AuthService.build(),
    },
    orgaoId: "",
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Novo Procedimento"
        : "Editar Procedimento";
    },
    allowCadastrarBtn() {
      return this.services.authService.temPermissao(
        endpoints["UnidadeController::POST->register"]
      );
    },
    allowEditarBtn() {
      return this.services.authService.temPermissao(
        endpoints["UnidadeController::POST->updateUnidadeData/$1"]
      );
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.options.desc = this.options.sortDesc[0] ?? false;
        this.atualizarListaOrgaos();
      },
      deep: true,
    },
    search(value, oldValue) {
      if (value.length > 2) {
        this.options.page = 1;
        this.atualizarListaOrgaos();
      }
      if (value.length == 0 && oldValue.length > 0) {
        this.options.page = 1;
        this.atualizarListaOrgaos();
      }
    },
  },

  mounted() {
    this.atualizarListaOrgaos();
  },

  methods: {
    forceRender() {
      this.render += 1;
    },
    atualizarListaOrgaos() {
      // const unidadeService = new UnidadeService();
      this.loading = true;
      this.orgaos = [];
      this.services.orgaoService
        .getOrgaoPaginatedList()
        .then(async (response) => {
          if (response.status !== 200) return;
          const { data } = await response.json();
          this.orgaos = data;
          // const { unidades, pagination } = data;
          // this.totalList = pagination.num_rows;
          // this.orgaos = unidades.map((unidade) => {
          //   return {
          //     pessoaJuridicaId: unidade.pessoa_juridica_id,
          //     nomeFantasia: unidade.nome_fantasia,
          //     razaoSocial: unidade.razao_social,
          //     cnpj: unidade.cnpj,
          //     // pessoaId: unidade.pessoa_id,
          //     telefone1: unidade.telefone_1,
          //     telefone2: unidade.telefone_2,
          //     observacao: unidade.observacao,
          //     // enderecoId: unidade.endereco_id,
          //     cep: unidade.cep,
          //     numero: unidade.numero,
          //     complemento: unidade.complemento,
          //     referencias: unidade.referencias,
          //     // cepId: unidade.cep_id,
          //     estado: unidade.estado,
          //     cidade: unidade.cidade,
          //     bairro: unidade.bairro,
          //     logradouro: unidade.logradouro,
          //     descricaoUnidade: unidade.descricao,
          //     unidadeId: unidade.unidade_id,
          //     chamefacil: unidade.chameFacil,
          //   };
          // });
        })
        .catch((error) => {
          console.error({ error });
        })
        .finally(() => {
          this.loading = false;
        });

      // this.services.orgaoService
      //   .getOrgaoPaginatedList({
      //     page: this.options.page,
      //     per_page: this.options.itemsPerPage,
      //     search: this.search,
      //     order: this.options.ordenacao,
      //     desc: this.options.desc,
      //   })
      //   .then(async (response) => {
      //     if (response.status !== 200) return;
      //     const { data } = await response.json();
      //     const { orgaos, pagination } = data;
      //     this.totalList = pagination.num_rows;
      //     this.orgaos = unidades.map((orgao) => {
      //       return {
      //         pessoaJuridicaId: orgao.pessoa_juridica_id,
      //         nomeFantasia: orgao.nome_fantasia,
      //         razaoSocial: orgao.razao_social,
      //         cnpj: orgao.cnpj,
      //         // pessoaId: unidade.pessoa_id,
      //         telefone1: orgao.telefone_1,
      //         telefone2: orgao.telefone_2,
      //         observacao: orgao.observacao,
      //         // enderecoId: unidade.endereco_id,
      //         cep: orgao.cep,
      //         numero: orgao.numero,
      //         complemento: orgao.complemento,
      //         referencias: orgao.referencias,
      //         // cepId: unidade.cep_id,
      //         estado: orgao.estado,
      //         cidade: orgao.cidade,
      //         bairro: orgao.bairro,
      //         logradouro: orgao.logradouro,
      //         descricaoUnidade: orgao.descricao,
      //         unidadeId: orgao.unidade_id,
      //         chamefacil: orgao.chameFacil,
      //       };
      //     });
      //   })
      //   .catch((error) => {
      //     console.error({ error });
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },

    loadingOrgao(pessoaJuridicaId) {
      this.orgao_detalhe = this.orgaos.find(
        (u) => u.pessoaJuridicaId === pessoaJuridicaId
      );
    },

    async editItem(item, visualizar) {
      this.editedIndex = this.orgaos.indexOf(item);
      // this.orgao = item;
      this.editedItem = Object.assign({}, item);
      this.loadingOrgao(this.orgao.pessoaJuridicaId);
      this.orgaoId = item.id_orgao;
      this.visualizar = visualizar;
      this.render = 1;
      this.dialog = true;
    },

    // editItem(item, visualizar) {
    //   this.editedIndex = this.orgaos.indexOf(item);
    //   this.orgao = item;
    //   this.visualizar = visualizar;
    //   this.editedItem = Object.assign({}, item);
    //   this.loadingOrgao(this.orgao.pessoaJuridicaId);
    //   this.render = 1;
    //   this.dialog = true;
    // },

    async getOrgaobyId(id) {
      this.services.orgaoService.getOrgaoById(id).then(async (response) => {
        if (response.status == 200) {
          const { data } = await response.json();
          this.editedItem = data[0];
        }
      });
    },

    close() {
      this.dialog = false;
      this.dialogCadastro = false;
      this.dialogObs = false;
      this.atualizarListaOrgaos();
      this.forceRender();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.dialogCadastro = false;
      if (this.editedIndex > -1) {
        Object.assign(this.orgaos[this.editedIndex], this.editedItem);
      } else {
        this.orgaos.push(this.editedItem);
      }
      this.orgao_detalhe = false;
      this.options.ordenacao = false;
      this.options.desc = false;
      this.close();
      this.atualizarListaOrgaos();
      this.forceRender();
    },
  },
};
</script>
